import ContactLink from './contactLink'

const LinkGroup = ({ contact }) => {
  return (
    <div className="lg:w-[200px] flex flex-col gap-y-[17px] lg:gap-y-smallDesktop">
      <ContactLink href={contact.instagram.link} target="_blank">
        {contact.instagram.name}
      </ContactLink>
      <ContactLink href={`mailto:${contact.email}`}>
        {contact.email}
      </ContactLink>
      <ContactLink target="_blank" href={contact.whatsapp.link}>
        {contact.whatsapp.phoneNumber}
      </ContactLink>
    </div>
  )
}

export default LinkGroup
